// Lokální nastavení. localStorage může v soukromém okně selhat, proto vše v try/catch.

/** zvuk = klávesnice a čtečka (NVDA); obraz = jen grafika; oboje; dotyk = grafika zpřístupněná pro dotykovou čtečku (VoiceOver). */
export type Mode = "zvuk" | "obraz" | "oboje" | "dotyk";

function get(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function set(key: string, value: string | null) {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    /* nic */
  }
}

export const store = {
  getName: () => get("ha.name") ?? "",
  setName: (v: string) => set("ha.name", v),
  getMode(): Mode | null {
    const v = get("ha.mode");
    return v === "zvuk" || v === "obraz" || v === "oboje" || v === "dotyk" ? v : null;
  },
  setMode: (v: Mode) => set("ha.mode", v),
  getVolume(): number {
    const v = Number(get("ha.volume"));
    return Number.isFinite(v) && get("ha.volume") !== null ? Math.min(1, Math.max(0, v)) : 0.8;
  },
  setVolume: (v: number) => set("ha.volume", String(v)),
  getToken: (room: string) => get(`ha.token.${room}`),
  setToken: (room: string, token: string | null) => set(`ha.token.${room}`, token),
};

export function hasAudio(mode: Mode) {
  return mode !== "obraz";
}

export function hasVisual(mode: Mode) {
  return mode !== "zvuk";
}

/** Ovládání klávesnicí přes hrací plochu s role="application" (NVDA, nebo zvuk i obraz na počítači). */
export function usesKeyboard(mode: Mode) {
  return mode === "zvuk" || mode === "oboje";
}

/** Grafika je zpřístupněná pro dotykovou čtečku (tlačítka s popisy místo skryté vrstvy). */
export function touchReader(mode: Mode) {
  return mode === "dotyk";
}
